(function($) {

$(document).ready(function(){
	if ($('.team-detail').length) {
		// toggle between destination details and villa listings
		$('.team-detail__toggle span').on('click',function(){
			$(this).addClass('current').siblings().removeClass('current');
			var index = $(this).parent().find('span').index($(this));
			$('.team-box').hide().eq(index).show();
			$('html, body').animate({
              scrollTop: $('.team-detail').offset().top - 60
            }, 600);
            $(window).trigger('blockHeight');
            Foundation.reInit('equalizer');
		});
	}
});

})( jQuery );
